module.exports = __webpack_public_path__ + "static/media/ow2ll22.ca2b6e72.png";